import { useEffect } from 'react';
import { useI18n } from '../../i18n/i18n-context';
import { cx } from '../../lib/cx';
import { useAccount } from '../account/account-context';
import { PlanChooser } from '../account/PlanChooser';
import { usePlanChooser } from '../account/usePlanChooser';
import './pricing.css';

/** The plans and what credits buy, with the same choosing as the plans dialog: the pricing page. */
export function PricingPage() {
  const { t } = useI18n();
  const { loadPlans } = useAccount();
  const chooser = usePlanChooser();

  useEffect(() => {
    loadPlans();
  }, [loadPlans]);

  return (
    <section className="pricing" aria-labelledby="pricing-heading">
      <div className="pricing-intro">
        <h1 id="pricing-heading">{t.pricing.title}</h1>
        <p className="page-description">{t.plans.intro}</p>
      </div>
      {/* Signing in first, or confirming a switch, takes the place of the plans. */}
      <div className={cx('pricing-plans', chooser.step !== 'plans' && 'pricing-plans--step')}>
        {chooser.step !== 'plans' && <h2 className="pricing-step">{chooser.title}</h2>}
        <PlanChooser chooser={chooser} onChanged={chooser.reset} />
      </div>
    </section>
  );
}
